var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "filter :",
                    "label-cols": "1",
                    "label-size": "sm",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: { size: "sm" },
                    model: {
                      value: _vm.filtro,
                      callback: function ($$v) {
                        _vm.filtro = $$v
                      },
                      expression: "filtro",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                staticClass: "table-mini",
                attrs: {
                  bordered: "",
                  striped: "",
                  responsive: "",
                  items: _vm.item.columns,
                  fields: _vm.fields,
                  "show-empty": "",
                  filter: _vm.filtro,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(calculate_field)",
                    fn: function (row) {
                      return [
                        _c("b-form-checkbox", {
                          attrs: { disabled: true },
                          model: {
                            value: row.item.calculated_field,
                            callback: function ($$v) {
                              _vm.$set(row.item, "calculated_field", $$v)
                            },
                            expression: "row.item.calculated_field",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(masked)",
                    fn: function (row) {
                      return [
                        _c("b-form-checkbox", {
                          attrs: { disabled: _vm.readonly },
                          model: {
                            value: row.item.masked,
                            callback: function ($$v) {
                              _vm.$set(row.item, "masked", $$v)
                            },
                            expression: "row.item.masked",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(sensitive_data)",
                    fn: function (row) {
                      return [
                        _c("b-form-checkbox", {
                          attrs: { disabled: _vm.readonly },
                          model: {
                            value: row.item.sensitive_data,
                            callback: function ($$v) {
                              _vm.$set(row.item, "sensitive_data", $$v)
                            },
                            expression: "row.item.sensitive_data",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "cell(business_definition)",
                    fn: function (row) {
                      return [
                        _c("b-form-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            size: "sm",
                            type: "text",
                            placeholder: "describe...",
                          },
                          model: {
                            value: row.item.business_definition,
                            callback: function ($$v) {
                              _vm.$set(row.item, "business_definition", $$v)
                            },
                            expression: "row.item.business_definition",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }